import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { useMemo } from 'react';
import debounce from 'react-utils/debounce';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchForm = styled(UIFormControl).withConfig({
  displayName: "CardSearchInput__SearchForm",
  componentId: "sc-11gdry0-0"
})(["width:100%;padding:10px;background-color:", ";"], theme.colors.GYPSUM);
const SearchFormInput = styled(UISearchInput).withConfig({
  displayName: "CardSearchInput__SearchFormInput",
  componentId: "sc-11gdry0-1"
})(["input:placeholder-shown{text-overflow:ellipsis;}"]);
const CardSearchInput = ({
  onSearchChange,
  placeholder
}) => {
  const searchPlaceholder = I18n.text(placeholder);
  const debouncedSearch = useMemo(() => debounce(e => {
    const search = e.target.value.trim();
    onSearchChange(search && search.length ? search : undefined);
  }, 400), [onSearchChange]);
  return /*#__PURE__*/_jsx(SearchForm, {
    "aria-label": searchPlaceholder,
    children: /*#__PURE__*/_jsx(SearchFormInput, {
      onChange: debouncedSearch,
      placeholder: searchPlaceholder,
      use: "on-dark"
    })
  });
};
export default CardSearchInput;